module.exports = __webpack_public_path__ + "img/whatisgallinasio.271341b4.svg";